import { any, async, fromJSX, nothing, stateful } from 'widgets-for-react';
import { isLoaded } from '../../../../Shared/api/apiTypes';
import { TippedActivitiesLayout } from './tippedActivities.layout';
import { initialTippedActivitiesBlockState } from './tippedActivities.state';
export const TippedActivitiesWidget = (props)=>stateful()((s0)=>any({
            key: 'EventOverview'
        })([
            // Render Layout
            fromJSX((setState)=>{
                return TippedActivitiesLayout({
                    ...props,
                    ...s0
                });
            }),
            // Manage async state updates
            async(nothing, {
                key: 'eventsLoader'
            })(s0.events).map((resultUpdater)=>(s0)=>{
                    const events = resultUpdater(s0.events);
                    return {
                        ...s0,
                        events
                    };
                })
        ]).map((a)=>a(s0)))(initialTippedActivitiesBlockState(props)).run((s0)=>s0);
export const addRegionToTippedActivitiesBlock = (props)=>(block)=>{
        if (block.kind != "tipped_activities") return block;
        if (!isLoaded(props.regions)) return block;
        const region = props.regions.find((r)=>r.locations.includes(props.locationId));
        return {
            ...block,
            regions: region ? [
                region.name
            ] : []
        };
    };
